import { app } from './app'
import { makePath } from './utils'
import { getFirestore, collection, getDocs, getDocsFromServer, query, where } from 'firebase/firestore'
import {
  useCollection as useColl,
  useCollectionOnce as useCollectionOnce_,
  useCollectionDataOnce as useCollectionDataOnce_,
} from 'react-firebase-hooks/firestore'
import castArray from 'lodash/castArray'

export const getCollection = (...segments) => {
  console.log('getDocs', segments)
  return getDocs(collection(getFirestore(app), makePath(...segments)))
}

// #902: a screen that only ever displays a handful of months around the one
// being viewed (Timesheet.js's month tab strip) must not pull every document
// the subcollection has ever accumulated as a live listener — measured at 91
// months for one long-serving employee. `year` is a plain number on every
// timesheet document (see NewTimesheetDialog.js), so a single-field `in`
// filter needs no composite index. The returned snapshot's `.query` carries
// this same filter, so a listener attached to it (useWatchCollection) stays
// scoped too, not just the initial read.
export const getCollectionInYears = (segments, years) => {
  console.log('getCollectionInYears', segments, years)
  return getDocs(query(
    collection(getFirestore(app), makePath(...segments)),
    where('year', 'in', years),
  ))
}

export const getCollectionFromServer = (...segments) => {
  console.log('getCollectionFromServer', segments)
  return getDocsFromServer(collection(getFirestore(app), makePath(...segments)))
}

export const useCollection = (path, options) => {
  return useColl(
    collection(getFirestore(app), ...castArray(path)),
    options
  )
}

export const useCollectionOnce = (path, options) => {
  return useCollectionOnce_(
    collection(getFirestore(app), ...castArray(path)),
    options
  )
}

export const useCollectionDataOnce = (path, options) => {
  return useCollectionDataOnce_(
    collection(getFirestore(app), ...castArray(path)),
    options
  )
}

export const collectionRef = (...segments) => collection(getFirestore(app), makePath(...segments))
